import cx from 'classnames';
import React, { useCallback, useEffect } from 'react';

import * as styles from './styles.css';
import Box, { BoxProps } from '../Box';

interface OverlayProps extends BoxProps {
  active: boolean;
  lockScroll?: boolean;
  onEscKeyDown?: (event: KeyboardEvent) => void;
  onClick?: (event: React.SyntheticEvent) => void;
}

const Overlay: React.FC<OverlayProps> = ({ active, lockScroll = true, onEscKeyDown, onClick, className, ...rest }) => {
  const handleEscKey = useCallback(
    (event: KeyboardEvent) => {
      if (active && onEscKeyDown && event.key === 'Escape') {
        onEscKeyDown(event);
      }
    },
    [active, onEscKeyDown],
  );

  const handleClick = useCallback(
    (event: React.SyntheticEvent) => {
      event.preventDefault();
      event.stopPropagation();
      if (onClick) {
        onClick(event);
      }
    },
    [onClick],
  );

  useEffect(() => {
    if (active && onEscKeyDown) {
      document.body.addEventListener('keydown', handleEscKey);
    }

    if (lockScroll) {
      if (active) {
        document.body.style.overflow = 'hidden';
      } else if (!document.querySelectorAll('[data-teamleader-ui="overlay"]')[1]) {
        document.body.style.overflow = '';
      }
    }

    return () => {
      if (active && lockScroll) {
        if (!document.querySelectorAll('[data-teamleader-ui="overlay"]')[1]) {
          document.body.style.overflow = '';
        }
      }

      if (onEscKeyDown) {
        document.body.removeEventListener('keydown', handleEscKey);
      }
    };
  }, [active, lockScroll, onEscKeyDown, handleEscKey]);

  return (
    <Box data-teamleader-ui="overlay" {...rest} onClick={handleClick} className={cx(styles['overlay'], className)} />
  );
};

export default Overlay;
